<template lang="pug">
    div
        template(v-if="withCard")
            Card.card-shadow
                template(v-if="textInSingleLine")
                    p(v-resize-text="{ratio:0.5, minFontSize: '12px', maxFontSize: maxFontSize, delay: 200}" style='margin-top: 20px;') {{ chartTitle }}: {{ formatString }}
                template(v-else)
                    p(v-resize-text="{ratio:0.5, minFontSize: '12px', maxFontSize: maxFontSize, delay: 200}") {{ formatString }}
                    p {{ chartTitle }}

        template(v-else)
            template(v-if="textInSingleLine")
                p(v-resize-text="{ratio:0.5, minFontSize: '12px', maxFontSize: maxFontSize, delay: 200}" style='margin-top: 20px;') {{ chartTitle }}: {{ formatString }}
            template(v-else)
                p(v-resize-text="{ratio:0.5, minFontSize: '12px', maxFontSize: maxFontSize, delay: 200}") {{ formatString }}
                p {{ chartTitle }}
        Spin(size="large" fix v-if="spinShow")
</template>
<script>
import bus from "@/libs/bus.js";
import { getEdgeChartData } from "@/api/monitor.js";
import numeral from "numeral";
import ResizeText from "vue-resize-text";

export default {
    name: "SingleNumWrapper",
    props: {
        chartType: { type: String, default: "" },
        chartTitle: { type: String, default: "chartTitle" },
        numeralFormat: { type: String, default: "0.00a" },
        decimalPlaces: { type: Number, default: 2 },
        numStringPrefix: { type: String, default: "" },
        numStringSuffix: { type: String, default: "" },

        groupNames: { type: Array, default: () => [] },
        tags: { type: Array, default: () => [] },
        serviceGroupNames: { type: Array, default: () => [] },
        domains: { type: Array, default: () => [] },
        appProfileNames: { type: Array, default: () => [] },
        origins: { type: Array, default: () => [] },
        originHosts: { type: Array, default: () => [] },
        originPorts: { type: Array, default: () => [] },
        latencyStatusNames: { type: Array, default: () => [] },
        edgeNames: { type: Array, default: () => [] },
        slbNames: { type: Array, default: () => [] },
        netflowIps: { type: Array, default: () => [] },
        dateRange: { type: String, default: "" },
        customTimeRange: { type: Array, default: () => [] },

        withCard: { type: Boolean, default: true },
        textInSingleLine: { type: Boolean, default: false },
        minFontSize: { type: String, default: "12px" },
        maxFontSize: { type: String, default: "52px" },

        apiEndpoint: { type: String, default: "" },

        isGetDataFromStore: { type: Boolean, default: false },
        calculateFormula: {},
    },
    directives: {
        ResizeText,
    },
    created() {},
    beforeDestroy() {
        bus.$off("searchChartData", this.getNginxData);
    },
    data() {
        return {
            spinShow: false,
            // num: "",
            formatString: "",
        };
    },
    methods: {
        getNginxData() {
            if (!this.isGetDataFromStore) {
                this.spinShow = true;
                var chartOptions = {
                    chartType: this.chartType,
                    groupNames: this.queryFilter.groupNames,
                    tags: this.queryFilter.tags,
                    serviceGroupNames: this.queryFilter.serviceGroupNames,
                    domains: this.queryFilter.domains,
                    appProfileNames: this.queryFilter.appProfileNames,
                    origins: this.queryFilter.origins,
                    originHosts: this.queryFilter.originHosts,
                    originPorts: this.queryFilter.originPorts,
                    slbNames: this.queryFilter.slbNames,
                    edgeNames: this.queryFilter.edgeNames,
                    netflowIps: this.queryFilter.netflowIps,
                    latencyStatusNames: this.queryFilter.latencyStatusNames,
                    dateRangeOptions: {
                        index: this.queryFilter.dateRangeOptions.index,
                        customTimeRange: this.queryFilter.dateRangeOptions.customTimeRange,
                    },
                    apiEndpoint: this.apiEndpoint,
                };

                getEdgeChartData(chartOptions).then((res) => {
                    this.spinShow = false;
                    this.formatString = this.formatNumToString(res.data.num);
                });
            } else {
                this.formatString = this.formatNumToString(this.calculateFormula);
            }
        },
        formatNumToString(num) {
            // console.log(num);
            let formatedNum = parseFloat(num).toFixed(this.decimalPlaces);
            // console.log(parseFloat(num));
            // console.log(formatedNum);
            formatedNum = numeral(num).format(this.numeralFormat);

            return this.numStringPrefix + formatedNum + this.numStringSuffix;
        },
    },
    mounted() {
        this.getNginxData();
        bus.$on("searchChartData", this.getNginxData);
    },
    computed: {
        // query 參數, 優先使用props, 否則去看store
        queryFilter() {
            var queryFilter = this.$store.state.dashboard.queryFilter;

            // 如果dashboardQueryFilter組件還沒生成, 那就先看store > queryGroupName
            var queryGroupName = this.$store.state.queryGroupName;
            return {
                groupNames:
                    this.groupNames.length > 0
                        ? this.groupNames
                        : queryGroupName !== "all"
                        ? [queryGroupName]
                        : queryFilter.groupNames,
                tags: this.tags.length > 0 ? this.tags : queryFilter.tags,
                serviceGroupNames:
                    this.serviceGroupNames.length > 0 ? this.serviceGroupNames : queryFilter.serviceGroupNames,
                domains: this.domains.length > 0 ? this.domains : queryFilter.serverNames,
                appProfileNames: this.appProfileNames.length > 0 ? this.appProfileNames : queryFilter.appProfileNames,
                origins: this.origins.length > 0 ? this.origins : queryFilter.origins,
                originHosts: this.originHosts.length > 0 ? this.originHosts : queryFilter.originHosts,
                originPorts: this.originPorts.length > 0 ? this.originPorts : queryFilter.originPorts,
                slbNames: this.slbNames.length > 0 ? this.slbNames : queryFilter.slbNames,
                edgeNames: this.edgeNames.length > 0 ? this.edgeNames : queryFilter.edgeNames,
                netflowIps: this.netflowIps.length > 0 ? this.netflowIps : queryFilter.netflowIps,
                latencyStatusNames:
                    this.latencyStatusNames.length > 0 ? this.latencyStatusNames : queryFilter.latencyStatusNames,
                dateRangeOptions: {
                    index: this.dateRange || queryFilter.dateRangeOptions.index,
                    customTimeRange:
                        this.customTimeRange.length > 0
                            ? customTimeRange
                            : queryFilter.dateRangeOptions.customTimeRange,
                },
            };
        },
    },
    watch: {
        calculateFormula(oldVal, newVal) {
            // console.log(newVal, oldVal);
            this.formatString = this.formatNumToString(this.calculateFormula);
        },
    },
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/dashboard/SingleNumWrapper.vue